module.exports = __webpack_public_path__ + "static/media/checkbox-on.147cc8b2.svg";